module.exports = __webpack_public_path__ + "assets/28a7ba101110a7860ca802fc3a3c9c1e.mp3";